import DashboardPageReducer from './DashboardPageReducer';

export default from './DashboardPageContainer';
export const DashboardPageReducers = {
  DashboardPageReducer,
};
